import { Typography } from "@mui/material";
import "./AddCoach.css";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddCoachForm from "../../../../Components/Organisms/Forms/AddCoachForm/AddCoachForm";
import { PulseLoader } from "react-spinners";
import config from "../../../../config";

function AddCoach({ url, editId, coach }) {
  return (
    <div className="mainContainer">
      <div className="cont">
        <div className="greyBoxVer">
          <Typography
            sx={{
              color: "primary.main",
              fontSize: { xs: "28px", md: "35px" },
              fontWeight: "500",
              marginBottom: "5px",
            }}
          >
            {editId ? "Edit Coach" : "Add New Coach"}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              marginBottom: "20px",
            }}
          >
            {editId ? (
              <>
                Here, you can edit an existing coach to your teams for the{" "}
                <strong>
                  {config.APP_NAME == "Code Reg"
                    ? "Code Challenge Competition"
                    : config.APP_NAME == "WeDo Reg"
                    ? "WeDo Challenge Competition"
                    : "International Robot Challenge Competition"}
                </strong>
                .
              </>
            ) : (
              <>
                Here, you can add a new coach to your teams for the{" "}
                <strong>
                  {config.APP_NAME == "Code Reg"
                    ? "Code Challenge Competition"
                    : config.APP_NAME == "WeDo Reg"
                    ? "WeDo Challenge Competition"
                    : "International Robot Challenge Competition"}
                </strong>
                . Please fill in the required details accurately to ensure the
                coach is successfully added to the team.
              </>
            )}
          </Typography>
          <Accordion
            sx={{
              boxShadow:
                "0px 0px 10px -1px rgba(0,0,0,0.2),0px 0px 1px -1px rgba(0,0,0,0.14),0px 1px 1px 0px rgba(0,0,0,0.12)",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Coach Registration Guidelines & Steps
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Coach Addition Guidelines:
              </Typography>
              <ol style={{ marginLeft: "30px" }}>
                <li>Each team can have one coach.</li>
                <li>
                  Ensure the coach's information is accurate and complete.
                </li>
                <li>
                  The contact number must be valid for communication purposes.
                </li>
              </ol>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Steps to Add a New Coach:
              </Typography>
              <ol style={{ marginLeft: "30px" }}>
                <li>Enter the coach's Full Name.</li>
                <li>
                  Provide the coach's Contact Number (ensure it is active and
                  correct).
                </li>
                <li>
                  Confirm the addition by reviewing the details and clicking the
                  "Add" button.
                </li>
              </ol>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="greyBoxVer">
          {(editId && coach) || !editId ? (
            <AddCoachForm
              url={url}
              coach={coach}
              Edit={editId ? true : false}
              editId={editId}
            />
          ) : (
            <div className="loadingBox">
              <PulseLoader color={config.PRIMARY_COLOR} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddCoach;
